<template>
  <div class="helpPane">
    <div class="tiele">
      <span>客服&帮助</span>
      <!-- <div class="closeBtn" @click="close()" v-on:click.stop></div> -->
    </div>
    <div class="helpLsit">
      <div class="newGudie" @click="newGudie()" v-on:click.stop>
        <i class="font iconfont icona-2011"></i>
        <span>新手指引</span>
      </div>
      <div class="useTutorial" @click="useTutorial()" v-on:click.stop>
        <i class="font iconfont icona-2012"></i>
        <span>使用教程</span>
      </div>
      <div class="videoTutorial" @click="videoTutorial()" v-on:click.stop>
        <i class="font iconfont icona-2013"></i>
        <span>视频教程</span>
      </div>
      <div class="hotKey" @click="openHotKey($event)" v-on:click.stop>
        <i class="font iconfont icona-2014"></i>
        <span>快捷键</span>
      </div>
      <!-- <div class="versionUpdate" @click.stop="versionUpdate">
        <i class="font iconfont icona-2015"></i>
        <span>功能更新</span>
      </div>
      <div class="videoMsg" @click="videoMsg()" v-on:click.stop>
        <i class="font iconfont icona-2016"></i>
        <span>视频短信</span>
      </div> -->
      <div class="customMade" @click="customMade()" v-on:click.stop>
        <i class="font iconfont icona-2017"></i>
        <span>定制需求</span>
      </div>
      <div class="marketing-pack" style="display: flex; position: relative;" v-on:click.stop>
        <div style="width: 20px; height: 20px; background-size: 100% 100%; background-repeat: no-repeat; background-image: url('data:image/png;base64,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')"></div>
        <span style="color: #E5792F; font-size: 14px; margin-left: 9px;">免费领取创作素材包</span>
        <div class="popover" style="position: absolute; bottom: 100%; right: 17px; padding-bottom: 8px;">
          <qr
            style="width: 180px; height: 180px;"
            :text="['扫码领取素材包', '300+高清背景/免抠素材']"
            :id="'1514100483881570304'"
            :isCheckWorksCount="false"
          ></qr>
        </div>
      </div>
    </div>
    <div
      @click="contactCustomerService()"
      v-on:click.stop
      class="customerService"
    >
      <i class="icon iconfont iconkefu"></i>
      <span>在线客服</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import qr from '../../widgets/qr.vue';

export default {
  name: "helpPane",
  data() {
    return {};
  },
  props: {},
  components: {
    qr
  },
  methods: {
    close() {
      this.$emit("closePane", {});
    },
    newGudie() {
      this.$bus.emit("getApiCourse");
      this.$store.commit("save_TopnavMsg", {
        isShowAnimCourseDialog: true,
      });
    },
    useTutorial() {
      window.open(" https://support.qq.com/products/408104/", "_blank");
    },
    videoTutorial() {
      window.open("https://www.laihua.com/college/guide?id=140917", "_blank");
    },
    openHotKey(el) {
      this.$bus.emit("FeaturesPop_vue", {
        name: "shortcuts",
        initialX: el.pageX - el.offsetX + 144,
        initialY: el.pageY - el.offsetY - 70,
        type: 1,
      });
    },
    versionUpdate() {
      this.$bus.emit("touchGuidance_vue");
      this.$util.localStorage.set("NEW_Version", {
        type: this.UserMsg.versionTOOL,
      });
    },
    videoMsg() {
      let link = document.createElement("a");
      link.href = "/videomsg";
      link.target = "_blank";
      link.click();
    },
    customMade() {
      this.$modal.show("customWorks");
    },
    contactCustomerService() {
      this.$store.dispatch('showServiceChat');
    },
  },
  watch: {},
  computed: {
    ...mapGetters(["UserMsg"]),
  },
};
</script>

<style scoped lang="scss">
.helpPane {
  position: relative;
  width: 233px;
  background: #ffffff;
  box-shadow: 0px 6px 10px rgba(69, 70, 75, 0.1);
  overflow: hidden;
  padding: 18px 16px 25px 16px;
  text-align: left;

  .tiele {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    color: #474261;
    margin-bottom: 20px;
    .closeBtn {
      width: 12px;
      height: 12px;
      background-image: url(../../../../static/svg/materialPane/closePane.svg);
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
  .helpLsit {
    padding-top: 24px;
    width: 100%;
    border-top: 1px solid #E6E6E6;

    .newGudie,
    .useTutorial,
    .videoTutorial,
    .hotKey,
    .versionUpdate,
    .videoMsg,
    .customMade {
      font-size: 14px;
      color: #333;
      text-align: left;
      display: flex;
      justify-content: start;
      align-items: center;
      margin-bottom: 20px;
      &:hover {
        color: #5778fb;
        cursor: pointer;
      }
    }

    .iconLayout {
      width: 24px;
      height: 21px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 17px;
    }

    .newGudie {
      .font {
        font-size: 16px;
        margin-right: 12px;
      }
      .icon {
        width: 21px;
        height: 21px;
        background: url("../../../../static/svg/materialPane/navBtns/help/guide.svg")
          no-repeat center center;
      }
      &:hover {
        .icon {
          background: url("../../../../static/svg/materialPane/navBtns/help/guide-active.svg")
            no-repeat center center;
        }
      }
    }
    .useTutorial {
      .font {
        font-size: 18px;
        margin-right: 10px;
      }
      .icon {
        width: 21px;
        height: 21px;
        background: url("../../../../static/svg/materialPane/navBtns/help/useTutorial.svg")
          no-repeat center center;
      }
      &:hover {
        .icon {
          background: url("../../../../static/svg/materialPane/navBtns/help/useTutorial-active.svg")
            no-repeat center center;
        }
      }
    }
    .videoTutorial {
      .font {
        font-size: 18px;
        margin-right: 11px;
      }
      .icon {
        width: 24px;
        height: 21px;
        background: url("../../../../static/svg/materialPane/navBtns/help/videoTutorial.svg")
          no-repeat center center;
      }
      &:hover {
        .icon {
          background: url("../../../../static/svg/materialPane/navBtns/help/videoTutorial-active.svg")
            no-repeat center center;
        }
      }
    }
    .hotKey {
      .font {
        font-size: 18px;
        margin-right: 11px;
      }
      .icon {
        width: 24px;
        height: 18px;
        background: url("../../../../static/svg/materialPane/navBtns/help/hotKey.svg")
          no-repeat center center;
      }
      &:hover {
        .icon {
          background: url("../../../../static/svg/materialPane/navBtns/help/hotKey-active.svg")
            no-repeat center center;
        }
      }
    }
    .versionUpdate {
      .font {
        font-size: 18px;
        margin-right: 11px;
      }
      .icon {
        width: 24px;
        height: 18px;
        background: url("../../../../static/svg/materialPane/navBtns/help/versionUpdate.svg")
          no-repeat center center;
      }
      &:hover {
        .icon {
          background: url("../../../../static/svg/materialPane/navBtns/help/versionUpdate-active.svg")
            no-repeat center center;
        }
      }
    }
    .videoMsg {
      .font {
        font-size: 18px;
        margin-right: 12px;
      }
      .icon {
        width: 21px;
        height: 21px;
        background: url("../../../../static/svg/materialPane/navBtns/help/videoMsg.svg")
          no-repeat center;
      }
      &:hover {
        .icon {
          background: url("../../../../static/svg/materialPane/navBtns/help/videoMsg-active.svg")
            no-repeat center;
        }
      }
    }
    .customMade {
      .font {
        font-size: 18px;
        margin-right: 12px;
      }
      .icon {
        width: 21px;
        height: 22px;
        background: url("../../../../static/svg/materialPane/navBtns/help/customMade.svg")
          no-repeat center;
      }
      &:hover {
        .icon {
          background: url("../../../../static/svg/materialPane/navBtns/help/customMade-active.svg")
            no-repeat center;
        }
      }
    }
  }
  .customerService {
    width: 201px;
    height: 40px;
    background: #5778FB;
    border-radius: 4px;
    font-size: 14px;
    color: #ffffff;
    margin-top: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    .icon {
      width: 18px;
      height: 17px;
      margin-right: 12px;
    }
    &:hover {
      cursor: pointer;
    }
  }
}
.marketing-pack {
  .popover {
    display: none;
  }
  &:hover {
    .popover {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rightnav/controls/helpPane.vue